import Action from 'actions';
import BaseExecutor from 'services/sports/default/base-executor';
import {MinAdjustedPlayersValidator} from 'services/validations/draftkings/min-adjusted-players-validator';
import BaseValidator from 'services/validations/base-validator';

class MinAdjustedPlayersValidatorBuilder extends BaseExecutor {
    constructor({propNameOfDefaultUserPointsValue}) {
        super();
        this._propNameOfDefaultUserPointsValue = propNameOfDefaultUserPointsValue;
    }
    getInterface() {
        const {
            playersData: {preparedPlayers},
            playersLock,
            sportConfig,
        } = Action.getState();

        const validator = new BaseValidator();

        if (!sportConfig.isModeMain()) {
            return validator;
        }

        const players = preparedPlayers.groupedBy.position();

        const minAdjustedPlayersValidator = new MinAdjustedPlayersValidator();
        minAdjustedPlayersValidator.setDependencies({
            players,
            playersLock,
            propNameOfDefaultUserPointsValue: this._propNameOfDefaultUserPointsValue,
        });

        validator.addSubValidators([minAdjustedPlayersValidator]);

        return validator;
    }
}

export {MinAdjustedPlayersValidatorBuilder};
